export default __webpack_public_path__ + "static/media/gallery_06.612cbe61.jpg";